export const UKRAINIAN_REGIONS = new Map([
  [
    "Kyiv Oblast",
    {
      mainCity: "Kyiv",
      cities: ["Kyiv", "Bila Tserkva", "Brovary", "Irpin", "Fastiv"],
    },
  ],
  [
    "Kharkiv Oblast",
    {
      mainCity: "Kharkiv",
      cities: ["Kharkiv", "Izium", "Kupiansk", "Chuhuiv"],
    },
  ],
  [
    "Odesa Oblast",
    {
      mainCity: "Odesa",
      cities: [
        "Odesa",
        "Odessa",
        "Izmail",
        "Bilhorod-Dnistrovskyi",
        "Chornomorsk",
      ],
    },
  ],
  [
    "Dnipropetrovsk Oblast",
    {
      mainCity: "Dnipro",
      cities: ["Dnipro", "Kryvyi Rih", "Kamianske", "Novomoskovsk"],
    },
  ],
  [
    "Zaporizhzhia Oblast",
    {
      mainCity: "Zaporizhzhia",
      cities: ["Zaporizhzhia", "Melitopol", "Berdiansk", "Enerhodar"],
    },
  ],
  [
    "Lviv Oblast",
    { mainCity: "Lviv", cities: ["Lviv", "Drohobych", "Stryi", "Truskavets"] },
  ],
  [
    "Mykolaiv Oblast",
    { mainCity: "Mykolaiv", cities: ["Mykolaiv", "Pervomaisk", "Yuzhne"] },
  ],
  [
    "Donetsk Oblast",
    {
      mainCity: "Donetsk",
      cities: ["Donetsk", "Mariupol", "Kramatorsk", "Sloviansk"],
    },
  ],
  [
    "Luhansk Oblast",
    { mainCity: "Luhansk", cities: ["Luhansk", "Sievierodonetsk", "Alchevsk"] },
  ],
  [
    "Vinnytsia Oblast",
    { mainCity: "Vinnytsia", cities: ["Vinnytsia", "Khmilnyk", "Zhmerynka"] },
  ],
  [
    "Kherson Oblast",
    { mainCity: "Kherson", cities: ["Kherson", "Nova Kakhovka", "Kakhovka"] },
  ],
  [
    "Poltava Oblast",
    { mainCity: "Poltava", cities: ["Poltava", "Kremenchuk", "Lubny"] },
  ],
  [
    "Chernihiv Oblast",
    { mainCity: "Chernihiv", cities: ["Chernihiv", "Nizhyn", "Pryluky"] },
  ],
  [
    "Cherkasy Oblast",
    { mainCity: "Cherkasy", cities: ["Cherkasy", "Uman", "Smila"] },
  ],
  ["Sumy Oblast", { mainCity: "Sumy", cities: ["Sumy", "Konotop", "Shostka"] }],
  [
    "Zhytomyr Oblast",
    { mainCity: "Zhytomyr", cities: ["Zhytomyr", "Berdychiv", "Korosten"] },
  ],
  [
    "Khmelnytskyi Oblast",
    {
      mainCity: "Khmelnytskyi",
      cities: ["Khmelnytskyi", "Kamianets-Podilskyi", "Shepetivka"],
    },
  ],
  [
    "Chernivtsi Oblast",
    { mainCity: "Chernivtsi", cities: ["Chernivtsi", "Storozhynets"] },
  ],
  [
    "Rivne Oblast",
    { mainCity: "Rivne", cities: ["Rivne", "Dubno", "Kostopil"] },
  ],
  [
    "Ivano-Frankivsk Oblast",
    {
      mainCity: "Ivano-Frankivsk",
      cities: ["Ivano-Frankivsk", "Kolomyia", "Kalush"],
    },
  ],
  [
    "Kirovohrad Oblast",
    {
      mainCity: "Kropyvnytskyi",
      cities: ["Kropyvnytskyi", "Oleksandriia", "Svitlovodsk"],
    },
  ],
  [
    "Ternopil Oblast",
    { mainCity: "Ternopil", cities: ["Ternopil", "Chortkiv", "Kremenets"] },
  ],
  ["Volyn", { mainCity: "Lutsk", cities: ["Lutsk", "Kovel", "Novovolynsk"] }],
  [
    "Zakarpattia Oblast",
    { mainCity: "Uzhhorod", cities: ["Uzhhorod", "Mukachevo", "Berehove"] },
  ],
]);
